import { CognitoAuthAdapter } from './cognito-adapter';
import type { AuthAdapter } from './types';

// Sessions from the retired Supabase login can linger in browser storage.
const isLegacyAuthStorageKey = (key: string) =>
  key === 'supabase.auth.token' ||
  key.includes('supabase.auth.token') ||
  (key.startsWith('sb-') && key.endsWith('-auth-token'));

const clearLegacyAuthStorage = () => {
  if (typeof window === 'undefined') return;

  [window.localStorage, window.sessionStorage].forEach((storage) => {
    Object.keys(storage)
      .filter(isLegacyAuthStorageKey)
      .forEach((key) => storage.removeItem(key));
  });
};

const createAuthService = (): AuthAdapter => {
  clearLegacyAuthStorage();
  return new CognitoAuthAdapter();
};

export const authService = createAuthService();
